import React from 'react'
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types'

import { useSelector } from "react-redux";

import HeaderDefault from './Default';
import HeaderCheckout from './HeaderCheckout/HeaderCheckout';

const HeaderRoutes = () => {
  const location = useLocation();
  const Oidc = useSelector(({ oidc }) => oidc)

  const isCheckoutPage = (location.pathname === '/checkout');

  if (!Oidc?.user?.profile) return <></>;

  return (
    <div>
      {isCheckoutPage ? (
        <HeaderCheckout />
      ) : (
        <HeaderDefault />
      )}
    </div>
  );
};


HeaderRoutes.propTypes = {
  headerParams: PropTypes.object
}


export default HeaderRoutes
